// useEscapeTimer.js
// Elapsed-seconds ticker for the main room. Starts ticking as soon as
// `running` is true (GamePage passes true from mount) and freezes the moment
// `running` becomes false (game complete) — a single interval, cleaned up on
// every dependency change and on unmount, per the Phase 4 spec.
//
// `initialSeconds` (Phase 5) seeds the counter from a resumed backend save
// so a refresh doesn't restart the clock at 00:00.
import { useEffect, useRef, useState } from 'react';

export function useEscapeTimer(running, initialSeconds = 0) {
  const [seconds, setSeconds] = useState(initialSeconds);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!running) {
      return undefined;
    }

    intervalRef.current = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [running]);

  return seconds;
}
